import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";


// GET ALL SUBCATEGORIES

export const GetAllSubCategory = createAsyncThunk(
  "masters/subcategory/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.subcategory}?name=${filter?.name || ""}&category_id=${
          filter?.category_id || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${
          filter?.per_page || IDS.PERPAGE
        }`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// GET SPECIFIC SUBCATEGORY

export const GetSubCategory = createAsyncThunk(
  "masters/subcategory/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.subcategory}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// ADD SUBCATEGORY (FORMDATA)

export const AddSubCategory = createAsyncThunk(
  "masters/subcategory/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.subcategory, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// UPDATE SUBCATEGORY (FORMDATA)

export const UpdateSubCategory = createAsyncThunk(
  "masters/subcategory/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Masters.subcategory}/${id}?_method=PUT`,
        data
      ); 
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// DELETE SUBCATEGORY

export const DeleteSubCategory = createAsyncThunk(
  "masters/subcategory/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.subcategory}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// CHANGE STATUS SUBCATEGORY

export const StatusSubCategory = createAsyncThunk(
  "masters/subcategory/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.subcategory}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// SLICE

export const Slice = createSlice({
  name: "subcategory",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get All
      .addCase(GetAllSubCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllSubCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages =
          action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllSubCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Get One
      .addCase(GetSubCategory.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })

      // Add
      .addCase(AddSubCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddSubCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddSubCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Update
      .addCase(UpdateSubCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateSubCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (x) => x.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateSubCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Delete
      .addCase(DeleteSubCategory.fulfilled, (state, action) => {
        state.data = state.data.filter((x) => x.id !== action.payload);
      })

      // Status Change
      .addCase(StatusSubCategory.fulfilled, (state, action) => {
        const index = state.data.findIndex(
          (x) => x.id === action.payload?.id
        );
        if (index !== -1) {
          state.data[index].status = !state.data[index].status;
        }
      });
  },
});

export default Slice.reducer;
